// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { AccessToHallRestrictedModal } from './access-to-hall-restricted'

const COMPONENT_ID = 'accessToHallRestrictedBecauseOfPayment'

type AccessToHallRestrictedModalProps = Parameters<
  typeof AccessToHallRestrictedModal
>[0]

type ShowAccessToHallRestrictedProps = Omit<
  AccessToHallRestrictedModalProps,
  'isOpen' | 'onClose'
> &
  Partial<Pick<AccessToHallRestrictedModalProps, 'onClose'>>

export const showAccessToHallRestrictedBecauseOfPaymentModal = (
  props: ShowAccessToHallRestrictedProps,
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: AccessToHallRestrictedModal,
  },
}
